import React from "react";
import { useState, useEffect } from "react";

import { Form, Button, Col, Row, Spinner, Container } from "react-bootstrap";
import Cookies from "js-cookie";

import { getRequest, postRequest } from "../../api/axiosRequests";
import { PALETTE } from "../../common/ThemeConstants";

export default function UserExerciseMaximumList({ user }) {
  const [isLoading, setIsLoading] = useState(false);
  const [selectedExercise, setSelectedExercise] = useState(-1);
  const [userExercises, setUserExercises] = useState([]);
  const [isEditing, setIsEditing] = useState([]);

  const toggleIsEditingListAt = (idx) => {
    let newList = [...isEditing];
    let newVal = !newList[idx];
    if (newVal) {
      setSelectedExercise(idx);
    }
    newList.fill(false);
    newList[idx] = newVal;
    fetchData();
    setIsEditing(newList);
  };

  const updateUserExerciseValue = (idx, newValue) => {
    let newUserExercises = [...userExercises];
    newUserExercises[idx].maximumWeight = newValue;
    setUserExercises(newUserExercises);
  };

  const updateUserExerciseFavouriteValue = (idx, newValue) => {
    let newUserExercises = [...userExercises];
    newUserExercises[idx].favourite = newValue;
    setUserExercises(newUserExercises);
  };

  const cancelUpdate = (idx) => {
    setup();
  };

  const setup = () => {
    fetchData();
    const isEditingList = Array(userExercises.length).fill(false);
    setIsEditing(isEditingList);
  };

  async function fetchData() {
    const headers = { Authorization: localStorage.getItem("jwt") };
    const promise1 = getRequest(
      "userExerciseMaximumForUser/" + user.id,
      headers
    );
    const promise2 = getRequest("exerciseList/", headers);
    Promise.all([promise1, promise2])
      .then((values) => {
        const userExercisesData = values[0].data;
        const exercisesData = values[1].data;
        let userExercises = [];
        userExercisesData.forEach((element) => {
          userExercises.push(element);
        });
        const nonRelatedExercises = exercisesData.filter((e) => {
          return e.relatedExerciseMaximum === null && e.primary === true;
        });
        nonRelatedExercises.forEach((nonRelatedExercise, idx) => {
          let found = false;
          userExercises.forEach((userExercise) => {
            if (userExercise["exercise"] === nonRelatedExercise.id) {
              userExercise["name"] = nonRelatedExercise.name;
              found = true;
            }
          });
          if (!found) {
            userExercises.push({
              id: -idx,
              user: user.id,
              exercise: nonRelatedExercise.id,
              maximumWeight: 0,
              name: nonRelatedExercise.name,
              favourite: false,
            });
          }
        });
        setUserExercises(userExercises);
      })
      .catch((errs) => {});
  }

  async function userExerciseMaxWeightPostRequest(data) {
    const csrftoken = Cookies.get("csrftoken");
    const headers = {
      "X-CSRFToken": csrftoken,
      Authorization: localStorage.getItem("jwt"),
    };
    const response = await postRequest(
      "updateUserExerciseMaximum/",
      data,
      headers
    );
    return response;
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    if (selectedExercise < 0) {
      return;
    }
    setIsLoading(true);
    const data = userExercises[selectedExercise];
    userExerciseMaxWeightPostRequest(data)
      .then((res) => {
        setup();
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    setup();
  }, []);

  return (
    <div className="p-1">
      <Container
        className="rounded py-1"
        style={{ backgroundColor: PALETTE.LIGHTGRAY }}
      >
        <Row className="text-start pt-2" style={{ color: PALETTE.DARKGRAY }}>
          <p className="mb-1">Exercises RM (Repetition Maximum):</p>
        </Row>
        <Row className="d-flex flex-nowrap overflow-auto mx-2">
          {userExercises.map((e, i) => (
            <Col
              key={e.id}
              className="ml-2"
              style={{ maxWidth: "fit-content" }}
            >
              <Form
                style={{
                  width: "180px",
                  height: "fit-content",
                  maxWidth: "100%",
                }}
                className="p-2 border rounded my-1"
                onSubmit={handleSubmit}
                action="/private/adminExercises"
              >
                <div className="text-start ,t-1">
                  <Form.Group className="mb-3">
                    <Form.Label>{e.name}</Form.Label>
                    <Row>
                      <Col xs={8}>
                        <Form.Control
                          disabled={!isEditing[i]}
                          type="number"
                          aria-label="weight"
                          onChange={(event) =>
                            updateUserExerciseValue(i, event.target.value)
                          }
                          value={e.maximumWeight}
                        />
                      </Col>
                      <Col xs={4} className="align-self-center">
                        <span>kg</span>
                      </Col>
                    </Row>
                  </Form.Group>
                  <Form.Check
                    disabled={!isEditing[i]}
                    checked={e.favourite}
                    onChange={(event) =>
                      updateUserExerciseFavouriteValue(i, event.target.checked)
                    }
                    type={"checkbox"}
                    id={`default-checkbox`}
                    label={`Preferiti`}
                  />
                </div>
                {isEditing[i] && (
                  <>
                    <Button
                      size="sm"
                      className="mt-2"
                      style={{
                        width: "100%",
                        border: `1px solid ${PALETTE.RED}`,
                        backgroundColor: PALETTE.RED,
                      }}
                      onClick={() => {
                        cancelUpdate(i);
                      }}
                      disabled={isLoading}
                    >
                      {" "}
                      Cancel{" "}
                    </Button>
                    <Button
                      size="sm"
                      className="mt-1"
                      style={{ width: "100%" }}
                      variant="dark"
                      type="submit"
                      disabled={isLoading}
                    >
                      {isLoading && <Spinner animation="border" />}
                      {!isLoading && "Save"}
                    </Button>
                  </>
                )}
                {!isEditing[i] && (
                  <Button
                    className="mt-3"
                    style={{ width: "100%" }}
                    variant="dark"
                    onClick={() => toggleIsEditingListAt(i)}
                  >
                    {" "}
                    Edit{" "}
                  </Button>
                )}
              </Form>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}
